import api, { IDataRequest, IDataResponse } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { Carrinho } from "./types";

class CarrinhosProvider extends AProvider {
    constructor() {
        super("/loja/carrinhos");
    }

    async buscarCarrinhoPorGuid(guid: string): Promise<Carrinho | null> {
        const request: IDataRequest = { url: `${this.path}?guid=${guid}&includes=itens,itens.itens,avulsos,avulsos.componente` }
        const response: IDataResponse<Carrinho[]> = await api.get(request);
        return response.data?.[0] || null
    }
}

export { CarrinhosProvider }